<!-- <div id="terms">
<div class="container">
  <div class="d-flex justify-content-center mb-4">
    <app-logo [link]="DefualtPath"></app-logo>
  </div>

  <p class="desc indent">
    <strong
      ><span style="font-size: 19px; line-height: 107%"
      >BidXSell.com</span
      ></strong
      ><span style="font-size: 16px; line-height: 107%"
      >&nbsp;is owned by Silk Road, LLC, a company&nbsp;registered</span
      ><span style="font-size: 11px; line-height: 107%">&nbsp;</span
      ><span style="font-size: 16px; line-height: 107%"
      >&nbsp;in Saudi . &nbsp;Silk Road LLC has a registered office at King
      Abdullah Street, Jeddah, Makkah, Saudi Arabia 21415. &nbsp;This
      agreement to Terms of Service and Usage constitute a legally binding
      agreement made between ___________________________, herein after
      referred to as &ldquo;Consignor&rdquo;, &ldquo;user&rdquo;,
      &ldquo;you&rdquo;, or &ldquo;your&rdquo; and both Silk Road LLC
      and&nbsp; BidXSell.com herein after the &ldquo;Platform&rdquo;, the
      &ldquo;Site&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;, or
      &ldquo;our&rdquo;, concerning your access to and use of the</span
      ><span style="font-size: 11px; line-height: 107%">&nbsp;</span
      ><span style="font-size: 16px; line-height: 107%"
      >&nbsp;BidXSell.com website as well as any other media form, media
      channel, mobile website or mobile application related, linked, or
      otherwise connected thereto (collectively, the &ldquo;Site&rdquo; or the
      &ldquo;Platform&rdquo;).&nbsp;</span
      >
    </p>
    <p>&nbsp;</p>
    <h1>AGREEMENT TO TERMS</h1>
    <ol class="decimal">
      <li>
        You agree that by accessing the Site, you have read, understood, and
        agree to be bound by all of these Terms of Service and Usage, including
        the Services Agreement posted on the Site, which are incorporated into
        these Terms of Service and Usage. IF YOU DO NOT AGREE WITH ALL OF THESE
        TERMS OF SERVICE AND USAGE, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING
        THE SITE AND YOU MUST DISCONTINUE USE IMMEDIATELY.
      </li>
      <li>
        Supplemental terms and conditions or documents that may be posted on the
        Site from time to time are hereby expressly incorporated herein by
        reference. We reserve the right, in our sole discretion, to make changes
        or modifications to these Terms of Service and Usage at any time and for
        any reason. We will alert you about any changes by updating the “Last
        updated” date of these Terms of Service and Usage, and you waive any
        right to receive specific notice of each such change. Please ensure that
        you check the applicable Terms every time you use our Site so that you
        understand which Terms apply. You will be subject to, and will be deemed
        to have been made aware of and to have accepted, the changes in any
        revised Terms of Service and Usage by your continued use of the Site
        after the date such revised Terms of Service and Usage are posted.
      </li>
      <li>
        The information provided on the Site is not intended for distribution to
        or use by any person or regulation, any jurisdiction or country where
        such distribution or use would be contrary to law or regulation or which
        would subject us to any registration requirement within such
        jurisdiction or country. The Site is intended for users who are at least
        18 years old. Persons under the age of 18 are not permitted to use or
        register for the Site.
      </li>
    </ol>

    <h1>INTELLECTUAL PROPERTY RIGHTS</h1>
    <ol class="decimal">
      <li>
        Unless otherwise indicated, the Site is our proprietary property and all
        source code, databases, functionality, software, website designs, audio,
        video, text, photographs, and graphics on the Site (collectively, the
        “Content”) and the trademarks, service marks, and logos contained
        therein (the “Marks”) are owned or controlled by us or licensed to the
        Platform, and are protected by copyright and trademark laws and various
        other intellectual property rights and unfair competition laws of the
        United States, international copyright laws, and international
        conventions.
      </li>
      <li>
        Except as expressly provided in these Terms of Service and Usage, no
        part of the Site and no Content or Marks may be copied, reproduced,
        aggregated, republished, uploaded, posted, publicly displayed, encoded,
        translated, transmitted, distributed, sold, licensed, or otherwise
        exploited for any commercial purpose whatsoever, without our express
        prior written permission. Provided that you are eligible to use the
        Site, you are granted a limited license to access and use the Site and
        to download or print a copy of any portion of the Content to which you
        have properly gained access solely for your personal, non-commercial
        use. We reserve all rights not expressly granted to you in and to the
        Site, the Content and the Marks.
      </li>
    </ol>

    <h1>USER REPRESENTATIONS</h1>
    <p>By using the Site, you represent and warrant that:</p>
    <ol class="alpha">
      <li>
        You have the legal capacity and you agree to comply with these Terms of
        Service and Usage;
      </li>
      <li>You are not a minor in the jurisdiction in which you reside;</li>
      <li>
        You will not access the Site through automated or non-human means,
        whether through a bot, script or otherwise;
      </li>
      <li>
        You will not use the Site for any illegal or unauthorized purpose; and
      </li>
      <li>
        Your use of the Site will not violate any applicable law or regulation.
      </li>
      <li>
        you will only provide true, accurate, current an complete information.
        If you provide any information that is untrue, inaccurate, not current,
        or incomplete, we have the right to suspend or terminate your account
        and refuse any and all current or future use of the Site (or any portion
        thereof).
      </li>
    </ol>

    <h1>FEES, SUBSCRIPTION, AND PAYMENT</h1>
    <ol class="decimal">
      <li>
        BidXSell.com uses the following forms of payment: PayPal, American
        Express, Mastercard, Visa, Google Pay, Apple Pay, HyperPay, ACH or other
        payment forms available via the HyperPay gateway.
      </li>

      <li>
        The Consignor must enter into a contractual subscription and remit fees
        for entries created within the sale Platform to access the services
        provided by the Platform
      </li>
      <li>
        SUBSCRIPTION OBIGATION: The Consignor agrees to list and pay fees for a
        minimum of ten (10) sale entries per calendar year to fulfill the terms
        of the subscription. The ten entries required can be comprised of both
        Standard Sale Entries and Live Sale RNA Entries. No additional
        subscription charge will be assessed to any Consignor listing ten
        entries during a calendar year. Should the Consignor/User fail to list
        ten sale entries in any given calendar year, the outstanding balance of
        the subscription shall be charged based upon an annual subscription rate
        of $5,000 ($500 per entry for any outstanding entries during the
        calendar year). Annual subscription fees will be assessed and invoiced
        on December 31st (at the end) of the subscription year Subscription fees
        will be due within 30 days of the billing date
      </li>
      <li>
        FEES:
        <br />
        <p class="font-weight--bold">
          Standard Sale Entry &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; $500.00 (USD)
        </p>
        <p class="font-weight--bold">
          Live Sale RNA Entry &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; $350.00 (USD)
        </p>
        A Standard Sale Entry pertains to any horse not presently listed in and
        on the sale grounds of a live North American sale. Live Sale RNA denotes
        any horse entered in a live North American sale that did not attain the
        reserve sale price set by the horse’s owner. Live Sale RNA Entries must
        be submitted as an entry to the BidXSell.com platform within 7 days of
        the horse departing the sale ring of the live sale for which it fails to
        reach its reserve sales price.
      </li>
      <li>
        You agree to provide current, complete, and accurate purchase and
        account information for all purchases made via the Site. You further
        agree to promptly update account and payment information, including
        email address, payment method, and payment card expiration date.
        BidXSell.com will bill for sale listings through an online billing
        account for purchases made via the Site. Listing fees shall be subject
        to the addition of sales tax as mandated by the applicable laws
        governing the tax jurisdiction pertinent to the transaction.
      </li>
      <li>
        Prices are subject to annual adjustments. Notifications of forthcoming
        price modifications for the upcoming calendar year will be disseminated
        to all Platform users before the conclusion of the current calendar
        year. All monetary transactions shall be conducted in U.S. dollars. By
        creating a listing, you hereby consent to settle all applicable charges
        or fees at the prevailing rates for sale entries, authorizing the
        Platform to debit your designated payment provider for said amounts. We
        reserve the right to correct any errors or mistakes in pricing, even if
        we have already requested or received payment.
      </li>
    </ol>

    <h1>CANCELLATION</h1>
    <p>
      You can cancel your subscription at any time by contacting us using the
      contact information provided below. Your cancellation will take effect at
      the end of the current paid term, generally at the end of the calendar
      year. If you are unsatisfied with our services, please email us at
      <a href="mailto:kstuebs@bidxsell.com">kstuebs@bidxsell.com</a> or call us
      at 859-312-4115.
    </p>

    <h1>PROHIBITED ACTIVITIES</h1>
    <p>
      You may not access or use the Site for any purpose other than that for
      which we make the Site available. The Site may not be used in connection
      with any commercial endeavors except those that are specifically endorsed
      or approved by us. As a user of the Site, you agree not to:
    </p>
    <ol class="alpha">
      <li>
        Systematically retrieve data or other content from the Site to create or
        compile, directly or indirectly, a collection, compilation, database, or
        directory without written permission from us.
      </li>
      <li>
        Trick, defraud, or mislead us and other users, especially in any attempt
        to learn sensitive account information such as user passwords.
      </li>
      <li>
        Circumvent, disable, or otherwise interfere with security-related
        features of the Site, including features that prevent or restrict the
        use or copying of any Content or enforce limitations on the use of the
        Site and/or the Content contained therein.
      </li>
      <li>
        Disparage, tarnish, or otherwise harm, in our opinion, BidXSell.com, its
        parent company and/or its affiliates.
      </li>
      <li>
        Use any information obtained from the Site in order to harass, abuse, or
        harm another person.
      </li>
      <li>
        Make improper use of our support services or submit false reports of
        abuse or misconduct.
      </li>
      <li>
        Use the Site in a manner inconsistent with any applicable laws or
        regulations.
      </li>
      <li>Engage in unauthorized framing of or linking to the Site.</li>
      <li>
        Upload or transmit (or attempt to upload or to transmit) viruses, Trojan
        horses, or other material, including excessive use of capital letters
        and spamming (continuous posting of repetitive text), that interferes
        with any party’s uninterrupted use and enjoyment of the Site or
        modifies, impairs, disrupts, alters, or interferes with the use,
        features, functions, operation, or maintenance of the Site.
      </li>
      <li>
        Engage in any automated use of the system, such as using scripts to send
        comments or messages, or using any data mining, robots, or similar data
        gathering and extraction tools.
      </li>
      <li>
        Delete the copyright or other proprietary rights notice from any
        Content.
      </li>
      <li>
        Attempt to impersonate another user or person or use the username of
        another user.
      </li>
      <li>
        Upload or transmit (or attempt to upload or to transmit) any material
        that acts as a passive or active information collection or transmission
        mechanism, including without limitation, clear graphics interchange
        formats (“gifs”), 1×1 pixels, web bugs, cookies, or other similar
        devices (sometimes referred to as “spyware” or “passive collection
        mechanisms” or “pcms”).
      </li>
      <li>
        Interfere with, disrupt, or create an undue burden on the Site or the
        networks or services connected to the Site.
      </li>
      <li>
        Harass, annoy, intimidate, or threaten any of our employees or agents
        engaged in providing any portion of the Site to you.
      </li>
      <li>
        Attempt to bypass any measures of the Site designed to prevent or
        restrict access to the Site, or any portion of the Site.
      </li>
      <li>
        Copy or adapt the Site’s software, including but not limited to Flash,
        PHP, HTML, JavaScript, or other code.
      </li>
      <li>
        Except as permitted by applicable law, decipher, decompile, disassemble,
        or reverse engineer any of the software comprising or in any way making
        up a part of the Site.
      </li>
      <li>
        Except as may be the result of standard search engine or Internet
        browser usage, use, launch, develop, or distribute any automated system,
        including without limitation, any spider, robot, cheat utility, scraper,
        or offline reader that accesses the Site, or using or launching any
        unauthorized script or other software.
      </li>
      <li>
        Make any unauthorized use of the Site, including collecting usernames
        and/or email addresses of users by electronic or other means for the
        purpose of sending unsolicited email, or creating user accounts by
        automated means or under false pretenses.
      </li>
      <li>
        Use the Site as part of any effort to compete with us or otherwise use
        the Site and/or the Content for any revenue-generating endeavor or
        commercial enterprise.
      </li>
    </ol>

    <h1>USER GENERATED CONTRIBUTIONS</h1>
    <ol class="decimal">
      <li>
        The Site may invite you to chat, contribute to, or participate in
        proprietary social media, public social media, blogs, message boards,
        online forums, and other functionality, and may provide you with the
        opportunity to create, submit, post, display, transmit, perform,
        publish, distribute, or broadcast content and materials to BidXSell.com
        administration or on the Site, including but not limited to text,
        writings, video, audio, photographs, graphics, comments, suggestions, or
        personal information or other material (collectively, "Contributions").
      </li>
      <li>
        Contributions may be viewable by other users of the Site and through
        third-party websites. As such, any Contributions you transmit may be
        treated as non-confidential and non-proprietary. When you create or make
        available any Contributions, you thereby represent and warrant that: The
        creation, distribution, transmission, public display, or performance,
        and the accessing, downloading, or copying of your Contributions do not
        and will not infringe the proprietary rights, including but not limited
        to the copyright, patent, trademark, trade secret, or moral rights of
        any third party. You are the creator and owner of or have the necessary
        licenses, rights, consents, releases, and permissions to use and to
        authorize us, the Site, and other users of the Site to use your
        Contributions in any manner contemplated by the Site and these Terms of
        Service and Usage. You have the written consent, release, and/or
        permission of each and every identifiable individual person in your
        Contributions to use the name or likeness of each and every such
        identifiable individual person to enable inclusion and use of your
        Contributions in any manner contemplated by the Site and these Terms of
        Service and Usage.
      </li>
      <li>
        You agree your Contributions are not false, inaccurate, or misleading.
      </li>
      <li>
        You agree your Contributions are not unsolicited or unauthorized
        advertising, promotional materials, pyramid schemes, chain letters,
        spam, mass mailings, or other forms of solicitation. Your Contributions
        are not obscene, lewd, lascivious, filthy, violent, harassing, libelous,
        slanderous, or otherwise objectionable (as determined by us). Your
        Contributions do not ridicule, mock, disparage, intimidate, or abuse
        anyone. Your Contributions are not used to harass or threaten (in the
        legal sense of those terms) any other person and to promote violence
        against a specific person or class of people. Your Contributions do not
        violate any applicable law, regulation, or rule. Your Contributions do
        not violate the privacy or publicity rights of any third party. Your
        Contributions do not violate any applicable law concerning child
        pornography, or otherwise intended to protect the health or well-being
        of minors.
      </li>
      <li>
        You agree your Contributions do not otherwise violate, or link to
        material that violates, any provision of these Terms of Service and
        Usage, or any applicable law or regulation. Any use of the Site in
        violation of the foregoing violates these Terms of Service and Usage and
        may result in, among other things, termination or suspension of your
        rights to use the Site.
      </li>
    </ol>

    <h1>CONTRIBUTION LICENSE</h1>
    <ol class="decimal">
      <li>
        By posting your Contributions to any part of the Site, you automatically
        grant, and you represent and warrant that you have the right to grant,
        to us an unrestricted, unlimited, irrevocable, perpetual, non-exclusive,
        transferable, royalty-free, fully-paid, worldwide right, and license to
        host, use, copy, reproduce, disclose, sell, resell, publish, broadcast,
        retitle, archive, store, cache, publicly perform, publicly display,
        reformat, translate, transmit, excerpt (in whole or in part), and
        distribute such Contributions (including, without limitation, your image
        and voice) for any purpose, commercial, advertising, or otherwise, and
        to prepare derivative works of, or incorporate into other works, such
        Contributions, and grant and authorize sublicenses of the foregoing.
      </li>
      <li>
        The use and distribution may occur in any media formats and through any
        media channels. This license will apply to any form, media, or
        technology now known or hereafter developed, and includes our use of
        your name, company name, and franchise name, as applicable, and any of
        the trademarks, service marks, trade names, logos, and personal and
        commercial images you provide. You waive all moral rights in your
        Contributions, and you warrant that moral rights have not otherwise been
        asserted in your Contributions.
      </li>
      <li>
        We do not assert any ownership over your Contributions. You retain full
        ownership of all of your Contributions and any intellectual property
        rights or other proprietary rights associated with your Contributions
      </li>
      <li>
        We are not liable for any statements or representations in your
        Contributions provided by you in any area on the Site. You are solely
        responsible for your Contributions to the Site and you expressly agree
        to exonerate BidXSell.com and its parent company from any and all
        responsibility and to refrain from any legal action against BidXSell.com
        and its parent company regarding your Contributions.
      </li>
      <li>
        We have the right, in our sole and absolute discretion, (1) to edit,
        redact, or otherwise change any Contributions; (2) to re-categorize any
        Contributions to place them in more appropriate locations on the Site;
        and (3) to pre-screen or delete any Contributions at any time and for
        any reason, without notice
      </li>
      <li>We have no obligation to monitor your Contributions.</li>
    </ol>

    <h1>MOBILE APPLICATION LICENSE</h1>
    <ol class="decimal">
      <li>
        USE LICENSE. If you access the Site via a mobile application, then we
        grant you a revocable, nonexclusive, non-transferable, limited right to
        install and use the mobile application on wireless electronic devices
        owned or controlled by you, and to access and use the mobile application
        on such devices strictly in accordance with the terms and conditions of
        this mobile application license contained in these Terms of Service and
        Usage.
      </li>
      <li>
        You shall not:
        <ol class="alpha">
          <li>
            except as permitted by applicable law, decompile, reverse engineer,
            disassemble, attempt to derive the source code of, or decrypt the
            application;
          </li>
          <li>
            make any modification, adaptation, improvement, enhancement,
            translation, or derivative work from the application;
          </li>
          <li>
            violate any applicable laws, rules, or regulations in connection
            with your access or use of the application;
          </li>
          <li>
            remove, alter, or obscure any proprietary notice (including any
            notice of copyright or trademark) posted by us or the licensors of
            the application;
          </li>
          <li>
            use the application for any revenue generating endeavor, commercial
            enterprise, or other purpose for which it is not designed or
            intended;
          </li>
          <li>
            make the application available over a network or other environment
            permitting access or use by multiple devices or users at the same
            time;
          </li>
          <li>
            use the application for creating a product, service, or software
            that is, directly or indirectly, competitive with or in any way a
            substitute for the application;
          </li>
          <li>
            use the application to send automated queries to any website or to
            send any unsolicited commercial e-mail; or
          </li>
          <li>
            use any proprietary information or any of our interfaces or our
            other intellectual property in the design, development, manufacture,
            licensing, or distribution of any applications, accessories, or
            devices for use with the application.
          </li>
        </ol>
      </li>
      <li>
        Apple and Android Devices: The following terms apply when you use a
        mobile application obtained from either the Apple Store or Google Play
        (each an “App Distributor”) to access the Site:
        <ol class="alpha">
          <li>
            the license granted to you for our mobile application is limited to
            a non-transferable license to use the application on a device that
            utilizes the Apple iOS or Android operating systems, as applicable,
            and in accordance with the usage rules set forth in the applicable
            App Distributor’s terms of service;
          </li>
          <li>
            we are responsible for providing any maintenance and support
            services with respect to the mobile application as specified in the
            terms and conditions of this mobile application license contained in
            these Terms of Service and Usage or as otherwise required under
            applicable law, and you acknowledge that each App Distributor has no
            obligation whatsoever to furnish any maintenance and support
            services with respect to the mobile application;
          </li>
          <li>
            in the event of any failure of the mobile application to conform to
            any applicable warranty, you may notify the applicable App
            Distributor, and the App Distributor, in accordance with its terms
            and policies, may refund the purchase price, if any, paid for the
            mobile application, and to the maximum extent permitted by
            applicable law, the App Distributor will have no other warranty
            obligation whatsoever with respect to the mobile application;
          </li>
          <li>
            you represent and warrant that
            <ol class="roman">
              <li>
                you are not located in a country that is subject to a U.S.
                government embargo, or that has been designated by the U.S.
                government as a “terrorist supporting” country and
              </li>
              <li>
                you are not listed on any U.S. government list of prohibited or
                restricted parties;
              </li>
            </ol>
          </li>
          <li>
            you must comply with applicable third-party terms of agreement when
            using the mobile application, e.g., if you have a VoIP application,
            then you must not be in violation of their wireless data service
            agreement when using the mobile application; and
          </li>
          <li>
            you acknowledge and agree that the App Distributors are third-party
            beneficiaries of the terms and conditions in this mobile application
            license contained in these Terms of Service and Usage, and that each
            App Distributor will have the right (and will be deemed to have
            accepted the right) to enforce the terms and conditions in this
            mobile application license contained in these Terms of Service and
            Usage against you as a thirdparty beneficiary thereof.
          </li>
        </ol>
      </li>
    </ol>

    <h1>THIRD-PARTY WEBSITES AND CONTENT</h1>
    <ol class="decimal">
      <li>
        The Site may contain (or you may be sent via the Site) links to other
        websites ("Third-Party Websites") as well as articles, photographs,
        text, graphics, pictures, designs, music, sound, video, information,
        applications, software, and other content or items belonging to or
        originating from third parties ("Third-Party Content"). Such Third-Party
        Websites and Third-Party Content are not investigated, monitored, or
        checked for accuracy, appropriateness, or completeness by us, and we are
        not responsible for any Third-Party Websites accessed through the Site
        or any Third-Party Content posted on, available through, or installed
        from the Site, including the content, accuracy, offensiveness, opinions,
        reliability, privacy practices, or other policies of or contained in the
        Third-Party Websites or the Third-Party Content.
      </li>
      <li>
        Inclusion of, linking to, or permitting the use or installation of any
        Third-Party Websites or any Third-Party Content does not imply approval
        or endorsement thereof by us. If you decide to leave the Site and access
        the Third-Party Websites or to use or install any Third-Party Content,
        you do so at your own risk, and you should be aware these Terms of
        Service and Usage no longer govern. You should review the applicable
        terms and policies, including privacy and data gathering practices, of
        any website to which you navigate from the Site or relating to any
        applications you use or install from the Site.
      </li>
      <li>
        Any purchases you make through Third-Party Websites will be through
        other websites and from other companies, and we take no responsibility
        whatsoever in relation to such purchases which are exclusively between
        you and the applicable third party. You agree and acknowledge that we do
        not endorse the products or services offered on Third-Party Websites and
        you shall hold us harmless from any harm caused by your purchase of such
        products or services. Additionally, you shall hold us harmless from any
        losses sustained by you or harm caused to you relating to or resulting
        in any way from any Third-Party Content or any contact with Third-Party
        Websites.
      </li>
    </ol>

    <h1>U.S. GOVERNMENT RIGHTS</h1>
    <p>
      Our services are “commercial items” as defined in Federal Acquisition
      Regulation (“FAR”) 2.101. If our services are acquired by or on behalf of
      any agency not within the Department of Defense (“DOD”), our services are
      subject to the terms of these Terms of Service and Usage in accordance
      with FAR 12.212 (for computer software) and FAR 12.211 (for technical
      data). This U.S. Government Rights clause is in lieu of, and supersedes,
      any other FAR, DFARS, or other clause or provision that addresses
      government rights in computer software or technical data under these Terms
      of Service and Usage.
    </p>

    <h1>SITE MANAGEMENT</h1>
    <p>We reserve the right, but not the obligation, to:</p>
    <ol class="decimal">
      <li>
        Monitor the Site for violations of these Terms of Service and Usage;
      </li>
      <li>
        Take appropriate legal action against anyone who, in our sole
        discretion, violates the law or these Terms of Service and Usage,
        including without limitation, reporting such user to law enforcement
        authorities;
      </li>
      <li>
        In our sole discretion and without limitation, refuse, restrict access
        to, limit the availability of, or disable (to the extent technologically
        feasible) any of your Contributions or any portion thereof;
      </li>
      <li>
        In our sole discretion and without limitation, notice, or liability, to
        remove from the Site or otherwise disable all files and content that are
        excessive in size or are in any way burdensome to our systems; and
      </li>
      <li>
        Otherwise manage the Site in a manner designed to protect our rights and
        property and to facilitate the proper functioning of the Site.
      </li>
    </ol>

    <h1>PRIVACY POLICY</h1>
    <p>
      We care about data privacy and security. Please review our Privacy Policy
      at BidXSell.com. By using the Site, you agree to be bound by our Privacy
      Policy, which is incorporated into these Terms of Service and Usage.
      Please be advised the Site is hosted in Egypt. If you access the Site from
      any other region of the world with laws or other requirements governing
      personal data collection, use, or disclosure that differ from applicable
      laws in Egypt, then through your continued use of the Site, you are
      transferring your data to Egypt, and you agree to have your data
      transferred to and processed in Egypt.
    </p>

    <h1>TERM AND TERMINATION</h1>
    <p>
      These Terms of Service and Usage shall remain in full force and effect
      while you use the Site. WITHOUT LIMITING ANY OTHER PROVISION OF THESE
      TERMS OF SERVICE AND USAGE, WE RESERVE THE RIGHT TO, IN OUR SOLE
      DISCRETION AND WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE
      SITE (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR ANY
      REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR BREACH OF ANY
      REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN THESE TERMS OF SERVICE
      AND USAGE OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY TERMINATE YOUR
      USE OR PARTICIPATION IN THE SITE OR DELETE ANY CONTENT OR INFORMATION THAT
      YOU POSTED AT ANY TIME, WITHOUT WARNING, IN OUR SOLE DISCRETION.If we
      terminate or suspend your account for any reason, you are prohibited from
      registering and creating a new account under your name, a fake or borrowed
      name, or the name of any third party, even if you may be acting on behalf
      of the third party. In addition to terminating or suspending your account,
      we reserve the right to take appropriate legal action, including without
      limitation pursuing civil, criminal, and injunctive redress.
    </p>

    <h1>MODIFICATIONS AND INTERRUPTIONS</h1>
    <ol class="decimal">
      <li>
        We reserve the right to change, modify, or remove the contents of the
        Site at any time or for any reason at our sole discretion without
        notice. However, we have no obligation to update any information on our
        Site. We also reserve the right to modify or discontinue all or part of
        the Site without notice at any time.
      </li>
      <li>
        We will not be liable to you or any third party for any modification,
        price change, suspension, or discontinuance of the Site.
      </li>
      <li>
        We cannot guarantee the Site will be available at all times. We may
        experience hardware, software, or other problems or need to perform
        maintenance related to the Site, resulting in interruptions, delays, or
        errors.
      </li>
      <li>
        We reserve the right to change, revise, update, suspend, discontinue, or
        otherwise modify the Site at any time or for any reason without notice
        to you. You agree that we have no liability whatsoever for any loss,
        damage, or inconvenience caused by your inability to access or use the
        Site during any downtime or discontinuance of the Site.
      </li>
      <li>
        Nothing in these Terms of Service and Usage will be construed to
        obligate us to maintain and support the Site or to supply any
        corrections, updates, or releases in connection therewith.
      </li>
    </ol>

    <h1>GOVERNING LAW</h1>
    <p>
      These Terms of Service and Usage and your use of the Site are governed by
      and construed in accordance with the laws of the Kingdom of Saudi Arabia
      applicable to agreements made, without regard to its conflict of law
      principles.
    </p>

    <h1>DISPUTE RESOLUTION</h1>
    <p>
      In the event of any dispute arising from or relating to the services
      provided, the parties involved agree to engage in good faith negotiations
      to resolve the matter amicably. If a resolution cannot be reached through
      negotiation, the parties are required to engage in mediation or
      alternative dispute resolution mechanisms before pursuing legal action.
      All legal remedies are constrained by the terms delineated in the
      "Limitations of Liability" section provided below. Both parties commit to
      working collaboratively to reach a fair and mutually acceptable
      resolution.
    </p>
    <h1>CORRECTIONS</h1>
    <p>
      There may be information on the Site that contains typographical errors,
      inaccuracies, or omissions, including descriptions, pricing, availability,
      and various other information. We reserve the right to correct any errors,
      inaccuracies, or omissions and to change or update the information on the
      Site at any time, without prior notice.
    </p>

    <h1>DISCLAIMER</h1>
    <p>
      THE SITE IS PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE THAT
      YOUR USE OF THE SITE AND OUR SERVICES WILL BE AT YOUR SOLE RISK. TO THE
      FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR
      IMPLIED, IN CONNECTION WITH THE SITE AND YOUR USE THEREOF, INCLUDING,
      WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR
      A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR
      REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE SITE’S CONTENT
      OR THE CONTENT OF ANY WEBSITES LINKED TO THE SITE AND WE WILL ASSUME NO
      LIABILITY OR RESPONSIBILITY FOR ANY (1) ERRORS, MISTAKES, OR INACCURACIES
      OF CONTENT AND MATERIALS, (2) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY
      NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF THE SITE, (3)
      ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL
      PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN, (4) ANY
      INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE SITE, (5) ANY
      BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR
      THROUGH THE SITE BY ANY THIRD PARTY, AND/OR (6) ANY ERRORS OR OMISSIONS IN
      ANY CONTENT AND MATERIALS OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED
      AS A RESULT OF THE USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE
      MADE AVAILABLE VIA THE SITE. WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR
      ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY
      A THIRD PARTY THROUGH THE SITE, ANY HYPERLINKED WEBSITE, OR ANY WEBSITE OR
      MOBILE APPLICATION FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND WE
      WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY
      TRANSACTION BETWEEN YOU AND ANY THIRD-PARTY PROVIDERS OF PRODUCTS OR
      SERVICES ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SITE, ANY
      HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION FEATURED IN ANY
      BANNER OR OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO OR IN ANY WAY
      BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND ANY
      THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES. AS WITH THE PURCHASE OF A
      PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD
      USE YOUR BEST JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE.
    </p>

    <h1>LIMITATIONS OF LIABILITY</h1>
    <p>
      IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO
      YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY,
      INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST
      REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM YOUR USE OF THE SITE,
      EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
      NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR LIABILITY
      TO YOU FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION,
      WILL AT ALL TIMES BE LIMITED TO THE LESSER OF THE AMOUNT PAID, IF ANY, BY
      YOU TO US DURING THE SIX (6) MONTH PERIOD PRIOR TO ANY CAUSE OF ACTION
      ARISING OR $5,000. USD. CERTAIN US STATE LAWS AND INTERNATIONAL LAWS DO
      NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION
      OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE
      DISCLAIMERS OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MAY HAVE
      ADDITIONAL RIGHTS.
    </p>

    <h1>INDEMNIFICATION</h1>
    <p>
      You, the Consignor, agree to defend, indemnify, and hold us, BidXSell.com,
      harmless, including our subsidiaries, affiliates, and all of our
      respective officers, agents, partners, and employees, from and against any
      loss, damage, liability, claim, or demand, including reasonable attorneys’
      fees and expenses, made by any third party due to or arising out of: (1)
      your Contributions; (2) use of the Site; (3) breach of these Terms of
      Service and Usage; (4) any breach of your representations and warranties
      set forth in these Terms of Service and Usage; (5) your violation of the
      rights of a third party, including but not limited to intellectual
      property rights; or (6) any overt harmful act toward any other user of the
      Site with whom you connected via the Site.
      <br />
      Notwithstanding the foregoing, we reserve the right, at your expense, to
      assume the exclusive defense and control of any mater for which you are
      required to indemnify us, and you agree to cooperate, at your expense,
      with our defense of such claims. We will use reasonable efforts to notify
      you of any such claim, action, or proceeding which is subject to this
      indemnification upon becoming aware of it.
    </p>

    <h1>USER DATA</h1>
    <ol class="decimal">
      <li>
        We will maintain certain data that you transmit to the Site for the
        purpose of managing the performance of the Site, as well as data
        relating to your use of the Site.
      </li>
      <li>
        Although we perform regular routine backups of data, you are solely
        responsible for all data that you transmit or that relates to any
        activity you have undertaken using the Site.
      </li>
      <li>
        You agree that we shall have no liability to you for any loss or
        corruption of any such data, and you hereby waive any right of action
        against us arising from any such loss or corruption of such data.
      </li>
    </ol>

    <h1>ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES</h1>
    <ol class="decimal">
      <li>
        Visiting the Site, sending us emails, and completing online forms
        constitute electronic communications. You consent to receive electronic
        communications, and you agree that all agreements, notices, disclosures,
        and other communications we provide to you electronically, via email and
        on the Site, satisfy any legal requirement that such communication be in
        writing.
      </li>
      <li>
        YOU HEREBY AGREE TO THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS,
        AND OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES, AND
        RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA THE SITE.
      </li>
      <li>
        You hereby waive any rights or requirements under any statutes,
        regulations, rules, ordinances, or other laws in any jurisdiction which
        require an original signature or delivery or retention of non-electronic
        records, or to payments or the granting of credits by any means other
        than electronic means.
      </li>
    </ol>
    <h1>MISCELLANEOUS</h1>
    <ol class="decimal">
      <li>
        These Terms of Service and Usage and any policies or operating rules
        posted by us on the Site or in respect to the Site constitute the entire
        agreement and understanding between you and us. Our failure to exercise
        or enforce any right or provision of these Terms of Service and Usage
        shall not operate as a waiver of such right or provision.
      </li>
      <li>
        These Terms of Service and Usage operate to the fullest extent
        permissible by law. We may assign any or all of our rights and
        obligations to others at any time.
      </li>
      <li>
        We shall not be responsible or liable for any loss, damage, delay, or
        failure to act caused by any cause beyond our reasonable control. If any
        provision or part of a provision of these Terms of Service and Usage is
        determined to be unlawful, void, or unenforceable, that provision or
        part of the provision is deemed severable from these Terms of Service
        and Usage and does not affect the validity and enforceability of any
        remaining provisions.
      </li>
      <li>
        There is no joint venture, partnership, employment or agency
        relationship created between you and us as a result of these Terms of
        Service and Usage or use of the Site.
      </li>
      <li>
        You agree that these Terms of Service and Usage will not be construed
        against us by virtue of having drafted them.
      </li>
      <li>
        You hereby waive any and all defenses you may have based on the
        electronic form of these Terms of Service and Usage and the lack of
        signing by the parties hereto to execute these Terms of Service and
        Usage.
      </li>
    </ol>

    <h1>CONTACT US</h1>
    <ol class="decimal">
      <li>
        In order to resolve a complaint regarding the Site or to receive further
        information regarding use of the Site, please contact us at:
        <a href="mailto:kstuebs@bidxsell.com">kstuebs@bidxsell.com</a>.
      </li>
    </ol>

    <p>
      <strong> <span class="title2"> IN WITNESS WHEREOF, </span> </strong>
      The parties have caused this Agreement to be executed by their duly
      authorized representative as of the date first above written.
    </p>

    <p>
      <span>Silk Road LLC and BidXSell.com</span><br />
      BY: Saeed Almaddah<br />
      Title: CEO<br />
      Signature: ___________________________<br />
      Date: ____________________<br />
      _____________________________ (Consignor/User)
    </p>
    <p>BY:</p>
    <p>Name: &nbsp; _______________________________________________</p>
    <p>Title: &nbsp; _________________________________________________</p>
    <p>&nbsp;</p>
    <p>Signature: ___________________________________________</p>
    <p>Date: ____________________</p>
  </div>
</div> -->


<div id="terms" class="container h-100">

  @if (!isLoading) {
    <div class="content" [innerHTML]="data" ></div>
  }
  @if (isLoading) {
    <div class="d-flex justify-content-center h-100 align-items-center ">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>
  }

</div>